export default {"src":"/_next/static/media/spin.bd4f4125.svg","height":1024,"width":896};